<template>
  <div v-if="useWrapper" :class="`form-ant-select-wrapper${wrapperClass ? ` ${wrapperClass}` : ''}`" data-type="select">
    <a-select
      v-bind="$attrs"
      :allowClear="$attrs?.allowEmpty || $attrs?.allowClear || false"
      :labelInValue="useSelectOption ? false : labelInValue"
      :showSearch="searchable || $attrs?.showSearch"
      :mode="multiple ? 'multiple' : tags ? 'tags' : mode || null"
      :optionLabelProp="useSelectOption ? null : _labelBy"
      :optionFilterProp="_trackBy"
      :options="useSelectOption ? undefined : _options"
      :value="useSelectOption ? _value?.[_trackBy] || undefined : _value"
      @update:value="returnValue"
      :placeholder="placeholder || ''"
      :filter-option="typeof $attrs?.filterOption !== 'undefined' ? $attrs?.filterOption : filterOption"
      :size="$attrs?.size || 'medium'"
      :open="open"
      @focus="focusHandler"
      @blur="blurHandler"
      @dropdownVisibleChange="dropdownVisibleChangeHandler"
      data-lpignore="true"
      class="w-full"
      ref="formAntdSelect"
    >
      <template v-slot:notFoundContent>
        <slot name="noResult">No matches found.</slot>
      </template>
      <template v-slot:placeholder>
        <slot name="placeholder">
          <div class="flex ml-1 text-gray-400">
            {{ placeholder || '' }}
          </div>
        </slot>
      </template>
      <template v-if="removeMenuItemSelectedIcon" v-slot:menuItemSelectedIcon> </template>
      <template v-if="useSelectOption">
        <a-select-option v-for="option in _options" :key="option.value" :label="option.label" :value="option.value" :disabled="option.disabled">
          <slot name="option" :option="option">
            {{ option.label || '' }}
          </slot>
        </a-select-option>
      </template>
      <template v-if="!useSelectOption" v-slot:optionLabel="props">
        <slot name="singleLabel" :option="props">
          {{ props?.label || '' }}
        </slot>
      </template>
      <template v-if="!useSelectOption" v-slot:option="props">
        <slot name="option" :option="props">
          {{ props?.label || '' }}
        </slot>
      </template>
      <template v-slot:tagRender="props">
        <slot name="tag" v-bind="props" :remove="props.onClose">
          <a-tag :closable="props.closable" :title="props.label" @close="props.onClose">
            {{ props?.label || '' }}
          </a-tag>
        </slot>
      </template>
    </a-select>
  </div>
  <template v-else>
    <a-select
      v-bind="$attrs"
      :allowClear="$attrs?.allowEmpty || $attrs?.allowClear || false"
      :labelInValue="useSelectOption ? false : labelInValue"
      :showSearch="searchable || $attrs?.showSearch"
      :mode="multiple ? 'multiple' : tags ? 'tags' : mode || null"
      :optionLabelProp="useSelectOption ? null : _labelBy"
      :optionFilterProp="_trackBy"
      :options="useSelectOption ? undefined : _options"
      :value="useSelectOption ? _value?.[_trackBy] || undefined : _value"
      @update:value="returnValue"
      :placeholder="placeholder || ''"
      :filter-option="typeof $attrs?.filterOption !== 'undefined' ? $attrs?.filterOption : filterOption"
      :size="$attrs?.size || 'medium'"
      :open="open"
      @focus="focusHandler"
      @blur="blurHandler"
      @dropdownVisibleChange="dropdownVisibleChangeHandler"
      data-lpignore="true"
      class="w-full"
      ref="formAntdSelect"
    >
      <template v-slot:notFoundContent>
        <slot name="noResult">No matches found.</slot>
      </template>
      <template v-slot:placeholder>
        <slot name="placeholder">
          <div class="flex ml-1 text-gray-400">
            {{ placeholder || '' }}
          </div>
        </slot>
      </template>
      <template v-if="removeMenuItemSelectedIcon" v-slot:menuItemSelectedIcon> </template>
      <template v-if="useSelectOption">
        <a-select-option v-for="option in _options" :key="option.value" :label="option.label" :value="option.value" :disabled="option.disabled">
          <slot name="option" :option="option">
            {{ option.label || '' }}
          </slot>
        </a-select-option>
      </template>
      <template v-if="!useSelectOption" v-slot:optionLabel="props">
        <slot name="singleLabel" :option="props">
          {{ props?.label || '' }}
        </slot>
      </template>
      <template v-if="!useSelectOption" v-slot:option="props">
        <slot name="option" :option="props">
          {{ props?.label || '' }}
        </slot>
      </template>
      <template v-slot:tagRender="props">
        <slot name="tag" v-bind="props" :remove="props.onClose">
          <a-tag :closable="props.closable" :title="props.label" @close="props.onClose">
            {{ props?.label || '' }}
          </a-tag>
        </slot>
      </template>
    </a-select>
  </template>
</template>

<script>
export default {
  name: 'FormAntdSelect',
  inheritAttrs: false,
  components: {},
  props: {
    /**
     * Value bound via v-model.
     */
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: ''
    },
    /**
     * This can be an array of values, array of objects or an object.
     */
    options: [Object, Array],
    /**
     * Placeholder.
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Select Mode.
     */
    mode: {
      type: String,
      default: ''
    },
    /**
     * Is Multiple Select.
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Is Tags Select.
     */
    tags: {
      type: Boolean,
      default: false
    },
    /**
     * Is label In Value (object value).
     */
    labelInValue: {
      type: Boolean,
      default: true
    },
    /**
     * Is Searchable Select.
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Is Close on Select.
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Is Return Object as Select Value.
     */
    returnObjectAsValue: {
      type: Boolean,
      default: false
    },
    /**
     * Use Option select component.
     */
    optionsLimit: {
      type: Number,
      default: 100000
    },
    /**
     * Use Option select component.
     */
    useSelectOption: {
      type: Boolean,
      default: false
    },
    /**
     * Remove Munu Item Selected Icon.
     */
    removeMenuItemSelectedIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Use Wrapper.
     */
    useWrapper: {
      type: Boolean,
      default: false
    },
    /**
     * Additional classes for the wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'object', 'open', 'close'],
  data() {
    return {
      open: false
    }
  },
  computed: {
    _value() {
      let val
      if (typeof this.modelValue != 'object') {
        val = this._options.find((item) => item[this._trackBy] == this.modelValue)
      } else {
        if (Array.isArray(this.modelValue) && typeof this.modelValue[0] != 'object') {
          // Must be string values so convert to objects.
          val = this.modelValue.map((item) => {
            return this._options.find((o) => o[this._trackBy] == item) ?? { value: item, label: item }
          })
        } else {
          val = this.modelValue
        }
      }

      return val
    },
    _options() {
      let options = this.options
      if (this.optionsLimit > 0) {
        options = options.slice(0, this.optionsLimit)
      }

      if (!Array.isArray(options) && typeof options == 'object') {
        let _options = []

        Object.keys(options).forEach((item) => {
          _options.push({ value: item, label: options[item] })
        })

        return _options
      } else if (typeof options[0] == 'string' || typeof options[0] == 'number') {
        return options.map((item) => {
          return { value: item, label: item }
        })
      }
      return options
    },
    _trackBy() {
      return this.$attrs?.optionFilterProp || this.$attrs.trackBy || 'value'
    },
    _labelBy() {
      return this.$attrs?.optionLabelProp || this.$attrs?.label || 'label'
    }
  },
  methods: {
    returnValue(value) {
      let preparedValue = value
      if (Array.isArray(value)) {
        let val = value.map((item) => {
          return item.value
        })
        preparedValue = val
      } else if (typeof value == 'object' && false) {
        preparedValue = value
      } else {
        let val = value ? value[this._trackBy] : ''
        preparedValue = val ? val.toString() : value
      }

      if (this.useSelectOption || !this.labelInValue || typeof value !== 'object') {
        let objectValue = this._options.find((item) => item?.[this._trackBy] === value)
        if (objectValue) {
          value = objectValue
        }
      }

      // emit the whole object in case someone wants it
      this.$emit('object', value)
      if (this.$attrs.onObject && typeof this.$attrs.onObject === 'function') {
        this.$attrs.onObject(value)
      }

      if (this.returnObjectAsValue) {
        preparedValue = value
      }
      // emit updateModel value
      this.$emit('update:modelValue', preparedValue)
      if (this.$attrs.onUpdateModelValue && typeof this.$attrs.onUpdateModelValue === 'function') {
        this.$attrs.onUpdateModelValue(preparedValue)
      }

      if (this.closeOnSelect) {
        this.open = false
      }
    },
    filterOption(inputValue, option) {
      let include = false
      if (typeof option === 'string' && option.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) {
        include = true
      } else if (typeof option === 'object') {
        const label = (option?.[this._labelBy] || '').toString().toLowerCase()
        const value = (option?.[this._trackBy] || '').toString().toLowerCase()
        const valueInput = inputValue.toString().toLowerCase()
        if (label.indexOf(valueInput) !== -1 || value.indexOf(valueInput) !== -1) {
          include = true
        }
      }
      return include
    },
    focusHandler() {
      this.open = true
      this.$emit('open')
    },
    blurHandler() {
      this.open = false
      this.$emit('close')
    },
    dropdownVisibleChangeHandler(open) {
      if (open) {
        this.open = open
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
:deep(.ant-select-selector) {
  width: 100%;
}
</style>
